// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"shippingAddress_sectionTitle__3GBFz","buttonLabel":"shippingAddress_buttonLabel__2Pnh3","componentContainer":"shippingAddress_componentContainer__2C2mC"};